module.exports = __webpack_public_path__ + "static/media/box-purple.3eb51f9b.svg";